import React from 'react'

export const Wishlist = (props:any) => {
    return (
        <div id ="wishlist">
            {props.title}</div>
    )
}